import { aiTagCategoryLabel, extractImportanceScoreRank } from '@/common/app/modules/recommend/aiTag'
import { aiTagEditPath } from '@/common/app/path'
import { AITagMaster } from '@/common/model/recommend/aiTag'

import TextButton from '@/components/view/atoms/button/TextButton'
import CheckBox from '@/components/view/atoms/checkbox/CheckBox'
import ClickableTableRow from '@/components/view/atoms/table/ClickableTableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text from '@/components/view/atoms/text/Text'
import InsideArea, { BgColor } from '@/components/view/layouts/area/InsideArea'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

export interface AITagEditForm {
  tag_name: string
  tag_category: string
  importance_score: string
}

interface Props {
  siteId: number
  tag: AITagMaster
  isScrolled: boolean
  selected: boolean
  onSelect: () => void
  onPreview: (tag: AITagMaster) => void
}

const AITagListRow = ({ siteId, tag, isScrolled, selected, onSelect, onPreview }: Props) => {
  const { name: importanceRankName, color: importanceRankColor } = extractImportanceScoreRank(
    tag.importance_score
  )

  return (
    <ClickableTableRow href={aiTagEditPath(siteId, tag.id)}>
      <TableRowItem checkbox sticky={0} width={40} scrollShadow={isScrolled}>
        <CheckBox name={'tagId'} checked={selected} onChange={() => onSelect()} />
      </TableRowItem>
      <TableRowItem>
        <TextButton size={14} link={aiTagEditPath(siteId, tag.id)}>
          {tag.tag_name}
        </TextButton>
      </TableRowItem>
      <TableRowItem width={200}>
        <Text size={14}>{aiTagCategoryLabel(tag.tag_category)}</Text>
      </TableRowItem>
      <TableRowItem width={160}>
        <Text color={importanceRankColor} weight='bold'>
          {importanceRankName}
        </Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={14}>{tag.created_at ? tag.created_at.slice(0, 10) : '-'}</Text>
      </TableRowItem>
      <TableRowItem width={88}>
        <Text size={14}>{tag.occurrence_count}件</Text>
      </TableRowItem>
      <TableRowItem width={320}>
        <InsideArea color={BgColor.SECONDARY}>
          <ItemAlign gapX={16}>
            {tag.product_count > 0 ? (
              <TextButton
                size={14}
                onClick={(e) => {
                  e.stopPropagation()
                  onPreview(tag)
                }}
              >
                {tag.product_count}件の商品
              </TextButton>
            ) : (
              <Text size={14}>0件の商品</Text>
            )}
            {tag.feature_count > 0 ? (
              <TextButton
                size={14}
                onClick={(e) => {
                  e.stopPropagation()
                  onPreview(tag)
                }}
              >
                {tag.feature_count}件の記事
              </TextButton>
            ) : (
              <Text size={14}>0件の記事</Text>
            )}
          </ItemAlign>
        </InsideArea>
      </TableRowItem>
    </ClickableTableRow>
  )
}

export default AITagListRow
